import Icon from '../components/Icon';

const Uv = Icon(
  'uv',
  <>
    <path
      fillRule="evenodd"
      d="M10.945 1.684c.408-.912 1.702-.912 2.11 0l1.67 3.735 3.824-1.46c.933-.356 1.848.56 1.492 1.492l-1.46 3.823 3.735 1.67c.912.409.912 1.703 0 2.111l-3.735 1.67 1.46 3.824c.356.933-.56 1.848-1.492 1.492l-3.823-1.46-1.67 3.735c-.409.912-1.703.912-2.111 0l-1.67-3.735-3.824 1.46c-.933.356-1.848-.56-1.492-1.492l1.46-3.823-3.735-1.67c-.912-.409-.912-1.703 0-2.111l3.735-1.67-1.46-3.824c-.356-.933.56-1.848 1.492-1.492l3.823 1.46zM12 3.099l-1.468 3.282c-.25.56-.894.826-1.467.608L5.706 5.706 6.99 9.065a1.156 1.156 0 0 1-.608 1.467L3.099 12l3.282 1.468c.56.25.826.894.608 1.467l-1.283 3.359 3.359-1.283a1.156 1.156 0 0 1 1.467.608L12 20.901l1.468-3.282c.25-.56.894-.826 1.467-.608l3.359 1.283-1.283-3.359a1.156 1.156 0 0 1 .608-1.467L20.901 12l-3.282-1.468a1.156 1.156 0 0 1-.608-1.467l1.283-3.359-3.359 1.283a1.156 1.156 0 0 1-1.467-.608z"
      clipRule="evenodd"
    />
  </>
);

export default Uv;
